import React from 'react';
import { noop, filter, includes, get } from 'lodash';
import { withRouter } from 'react-router-dom';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

// import { button as Button } from 'modules/button';
// import * as ROUTE_PATHS from 'constants/route-paths';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { isInbound } from 'resolvers/callStateEntities';

/*******************************/

// success view
export const authFlowCallerIdentificationStepSuccess = ( props ) => {

    // if outbound then show only `member` and `pharmacy` tab
    const tabs = isInbound() ? get( props, 'tabs', [] ) : filter( props.tabs, ( tab ) => {
        return includes( [
            'authFlowCallerIdentificationMember',
            'authFlowCallerIdentificationPharmacy'
        ], tab.name );
    } );

    return (
        <div className='ui-auth-flow-caller-identification-step'>

            {/* tabs widget */}
            <WidgetsTabFlow
                className='ui-auth-flow-caller-identification-step__tab-flow'
                activeTabIndex={ props.currentTab ? props.currentTab - 1 : null }
                onTabChange={ ( index ) => props.onTabChange( index + 1 ) }
                tabs={ tabs }
                onNextActionClick={ props.onNextActionClick }
            />
        </div>
    );
};

// set display name
authFlowCallerIdentificationStepSuccess.displayName = 'authFlowCallerIdentificationStepSuccess';

// set default props
authFlowCallerIdentificationStepSuccess.defaultProps = {
    currentTab: undefined,
    tabs: [],
    navActions: [],
    onNextActionClick: noop,
    onTabChange: noop,
    callState: {},
};

// prop types
authFlowCallerIdentificationStepSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowCallerIdentificationStepPreloader = () => {
    return (
        <div className='ui-auth-flow-caller-identification-step-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
authFlowCallerIdentificationStepPreloader.displayName = 'authFlowCallerIdentificationStepPreloader';

// set default props
authFlowCallerIdentificationStepPreloader.defaultProps = {};

// prop types
authFlowCallerIdentificationStepPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowCallerIdentificationStep as AuthFlowCallerIdentificationStep } from 'ui/views/widgets/authFlowCallerIdentificationStep';
 *
 * // render
 * <AuthFlowCallerIdentificationStep propName='propValue'/>
 */
export const authFlowCallerIdentificationStep = withNetworkState( authFlowCallerIdentificationStepPreloader, withRouter( authFlowCallerIdentificationStepSuccess ) );
